import Script from 'next/script'
import React from 'react'

// TODO: Move to a shared types file
declare global {
  interface Window {
    hbspt?: {
      forms: {
        create: (options: {
          portalId: string
          formId: string
          target: string
          onFormReady?: (formElement: HTMLFormElement) => void
          onFormSubmitted?: () => void
        }) => void
      }
    }
  }
}

const HubspotSubmitForm = ({ portalId, formId }: { portalId: string; formId: string }) => {
  return (
    <div id="blog-hubspot" style={{ width: '100%' }}>
      <Script
        src="//js.hsforms.net/forms/embed/v2.js"
        strategy="afterInteractive"
        onReady={() => {
          window.hbspt?.forms.create({
            portalId: portalId,
            formId: formId,
            target: '#blog-hubspot',

            onFormReady: (form) => {
              const recaptchaStyle = document.createElement('style')
              recaptchaStyle.textContent = `
                    .grecaptcha-badge,
                    .rc-anchor,
                    .rc-anchor-logo-large,
                    .rc-anchor-pt,
                    .rc-anchor-normal-footer,
                    .rc-anchor-invisible-text {
                    display: none !important;
                    }
                `
              document.head.appendChild(recaptchaStyle)

              const emailWrapper = form.querySelector('.hs_email') as HTMLDivElement
              const emailInput = emailWrapper?.querySelector(
                'input[type="email"]',
              ) as HTMLInputElement
              const submitButton = form.querySelector('input[type="submit"]') as HTMLInputElement
              const errorList = emailWrapper?.querySelector('.hs-error-msgs') as HTMLUListElement

              if (emailWrapper && emailInput && submitButton) {
                const inputGroup = document.createElement('div')
                inputGroup.style.display = 'flex'
                inputGroup.style.alignItems = 'center'
                inputGroup.style.gap = '8px'
                inputGroup.style.marginBottom = '4px'

                emailInput.placeholder = 'Your e-mail'
                emailInput.style.borderRadius = '12px'
                emailInput.style.border = '1px solid #4B5563'
                emailInput.style.padding = '12px'
                emailInput.style.color = '#F9FAFB'
                emailInput.style.fontSize = '16px'
                emailInput.style.fontWeight = '500'
                emailInput.style.height = '48px'
                emailInput.style.fontFamily = 'GeneralSans,sans-serif'
                emailInput.style.lineHeight = '20px'

                emailInput.addEventListener('focus', () => {
                  emailInput.style.borderColor = '#0F6FA6'
                })
                emailInput.addEventListener('blur', () => {
                  emailInput.style.borderColor = '#4B5563'
                })

                submitButton.style.color = 'transparent'
                submitButton.style.fontSize = '0'
                submitButton.style.textIndent = '-9999px'
                submitButton.value = ''

                submitButton.style.width = '42px'
                submitButton.style.height = '42px'
                submitButton.style.borderRadius = '100%'
                submitButton.style.backgroundColor = '#0F6FA6'
                submitButton.style.border = 'none'
                submitButton.style.cursor = 'pointer'
                submitButton.style.padding = '0'
                submitButton.style.backgroundRepeat = 'no-repeat'
                submitButton.style.backgroundPosition = 'center'
                submitButton.style.backgroundSize = '24px 24px'
                submitButton.style.backgroundImage = 'url("/assets/blog/arrow_right.webp")'
                submitButton.style.flexShrink = '0'

                inputGroup.appendChild(emailInput)
                inputGroup.appendChild(submitButton)

                const emailLabel = emailWrapper.querySelector('label')
                if (emailLabel) {
                  emailLabel.remove()
                }

                const inputDiv = emailWrapper.querySelector('.input')
                if (inputDiv) {
                  inputDiv.replaceChildren(inputGroup)
                }
              }

              if (errorList) {
                errorList.style.marginTop = '4px'
                errorList.style.marginBottom = '16px'
              }

              const buttonContainer = form.querySelector('.actions') as HTMLDivElement
              if (buttonContainer) {
                buttonContainer.style.display = 'none'
              }

              const errorEl = form.querySelector('.hs_error_rollup')
              if (errorEl) {
                ;(errorEl as HTMLDivElement).style.textAlign = 'center'
              }
            },
          })
        }}
      />
    </div>
  )
}

export default React.memo(HubspotSubmitForm)
